import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const AutomateRobot: FC<IIconsProps> = ({
  color,
  fillcolor,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  if (!fillcolor) {
    color = theme.palette.neutral['00'];
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="10"
        width="22"
        height="10"
        rx="2"
        fill={fillcolor}
        stroke={color}
        strokeWidth="2"
      />
      <rect
        x="4"
        y="7"
        width="16"
        height="16"
        rx="2"
        fill={fillcolor}
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M8 18C8 18 8.5 20 12 20C15.5 20 16 18 16 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8.5" cy="12.5" r="1.5" stroke={color} strokeWidth="2" />
      <circle cx="15.5" cy="12.5" r="1.5" stroke={color} strokeWidth="2" />
      <rect x="11" y="3" width="2" height="4" rx="1" fill={color} />
      <circle cx="12" cy="3" r="2" fill={color} />
    </svg>
  );
};

export default AutomateRobot;
